import { NursePractitioner } from '../types';
import useAuth from './useAuth';

// ----------------------------------------------------------------------

const useGetNursePractitioner = (nursePractitionerId: string) => {
  const { nursePractitioners } = useAuth();

  const getNursePractitioner = (id: string) => {
    return nursePractitioners.find(
      (_nursePractitioner: NursePractitioner) => _nursePractitioner.prenuvoId === id,
    );
  };
  const nursePractitioner = getNursePractitioner(nursePractitionerId);

  return { nursePractitioner, getNursePractitioner };
};

export default useGetNursePractitioner;
